import type { SVGProps } from "react";
import * as React from "react";

const SvgCornerUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.293 13.293a1 1 0 0 0 1.414 1.414zM20 9l.707.707a1 1 0 0 0 0-1.414zm-4.293-5.707a1 1 0 1 0-1.414 1.414zM3 20a1 1 0 1 0 2 0zM8 9V8zm7.707 5.707 5-5-1.414-1.414-5 5zm5-6.414-5-5-1.414 1.414 5 5zM5 20v-7H3v7zm0-7a3 3 0 0 1 .879-2.121L4.464 9.464A5 5 0 0 0 3 13zm.879-2.121A3 3 0 0 1 8 10V8a5 5 0 0 0-3.536 1.464zM8 10h12V8H8z"
    />
  </svg>
);
export default SvgCornerUpRight;
